import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { asChakraVariable } from '~/themes/colors/colors'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'

import { getName } from '@mangovoice/core'

import { sharedComponentColorKeys } from './_colors'

const Colors = sharedComponentColorKeys.Menu

export const MenuStyleValues = {
  anchoredYGap: '0.375rem',
  anchoredXGap: '0.375rem',
  defaultWidth: 'fit-content',
  defaultMaxHeight: '30vh',
  menuItemsGap: '0.25rem',
}

const MenuParts = [
  'container',
  'scrollerContainer',
  'scroller',
  'itemContainer',
  'dividedHeaderContainer',
  'headerContainer',
] as const

const helpers = createMultiStyleConfigHelpers(MenuParts)
export const MenuStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      height: 'auto',
      backgroundColor: Colors.Background,
      borderRadius: '0.375rem',
      border: '1px solid',
      borderColor: Colors.Border,
      boxShadow: `${asChakraVariable(Colors.BoxShadow)} 0px 4px 12px 0px`,
    },
    scrollerContainer: {
      flexDirection: 'column',
      flex: 1,
      overflow: 'hidden',
    },
    scroller: {
      display: 'flex',
      height: '100%',
    },
    itemContainer: {
      padding: '0.25rem',
      flexDirection: 'row',
      flex: 1,
      height: 'auto',
      width: 'full',
      gap: '0.25rem',
    },
    dividedHeaderContainer: {
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem',
      paddingLeft: '0.25rem',
      paddingRight: '0.25rem',
      borderBottom: `1px solid ${asChakraVariable(Colors.Separator)}`,
    },
    headerContainer: {
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem',
      paddingLeft: '0.25rem',
      paddingRight: '0.25rem',
    },
  },
})

export const useMenuStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof MenuParts>(
    getName({ MenuStyle }),
    props,
  )
}
